// GA4 Ecommerce DataLayer — Captibulle
// À inclure dans theme.liquid via <script src="{{ 'ga4-datalayer.js' | asset_url }}" defer></script>

// Utilitaire : formater un item Shopify pour GA4
function formatItem(item, index) {
  return {
    item_id: item.variant_id || item.id,
    item_name: item.product_title || item.title,
    item_variant: item.variant_title || "",
    price: item.price / 100,
    quantity: item.quantity || 1,
    index: index || 0
  };
}

function pushEcommerce(eventName, data) {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({ ecommerce: null });
  dataLayer.push({ event: eventName, ecommerce: data });
}

// ─── ADD TO CART ───────────────────────────────────────────
// NextSky publie un event custom "cart:updated" ou fait un fetch /cart/add.js
// On intercepte la réponse fetch en monkey-patching

(function () {
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";

    if (url.includes("/cart/add")) {
      const clone = response.clone();
      clone.json().then((data) => {
        const items = data.items || [data];
        pushEcommerce("add_to_cart", {
          currency: window.Shopify?.currency?.active || "EUR",
          value: items.reduce((sum, i) => sum + (i.price / 100) * i.quantity, 0),
          items: items.map(formatItem)
        });
      }).catch(() => {});
    }

    if (url.includes("/cart/change") || url.includes("/cart/update")) {
      const clone = response.clone();
      clone.json().then((cart) => {
        if (!cart.items) return;
        pushEcommerce("remove_from_cart", {
          currency: cart.currency || "EUR",
          value: cart.total_price / 100,
          items: cart.items.map(formatItem)
        });
      }).catch(() => {});
    }

    return response;
  };
})();

// ─── VIEW ITEM ─────────────────────────────────────────────
// Déclenché au chargement d'une fiche produit
if (window.__productGA4 && window.__productGA4.id) {
  const p = window.__productGA4;
  pushEcommerce("view_item", {
    currency: window.Shopify?.currency?.active || "EUR",
    value: p.price / 100,
    items: [{
      item_id: p.variant_id || p.id,
      item_name: p.title,
      item_variant: p.variant_title || "",
      price: p.price / 100,
      quantity: 1
    }]
  });
}